export { default } from "./SocialImpact";
